/**
 * OpenAPI definition
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


/**
 * 
 */
export interface DataCleanupAnalyzeResultItem { 
    dataInstanceUid: string;
    dataType: string;
    fieldId?: string;
    fieldValue?: string;
    action: DataCleanupAnalyzeResultItem.ActionEnum;
    problem: DataCleanupAnalyzeResultItem.ProblemEnum;
    description: string;
    createdAt: string;
}
export namespace DataCleanupAnalyzeResultItem {
    export type ActionEnum = 'UNKNOWN' | 'DELETE_INSTANCE' | 'CLEAR_FIELD' | 'MANUAL_FIX';
    export const ActionEnum = {
        Unknown: 'UNKNOWN' as ActionEnum,
        DeleteInstance: 'DELETE_INSTANCE' as ActionEnum,
        ClearField: 'CLEAR_FIELD' as ActionEnum,
        ManualFix: 'MANUAL_FIX' as ActionEnum
    };
    export type ProblemEnum = 'NOT_USED' | 'MISSING_REFERENCE' | 'INVALID_TYPE';
    export const ProblemEnum = {
        NotUsed: 'NOT_USED' as ProblemEnum,
        MissingReference: 'MISSING_REFERENCE' as ProblemEnum,
        InvalidType: 'INVALID_TYPE' as ProblemEnum
    };
}


